

export default class OptionValue
{
	constructor(label,value,disabled) 
	{
		this.label=label;
		this.value=value;
		this.disabled=disabled;
	}
}
